import { render, staticRenderFns } from "./objetivos-definidos-editar.vue?vue&type=template&id=71bdd8db&scoped=true&"
import script from "./objetivos-definidos-editar.vue?vue&type=script&lang=js&"
export * from "./objetivos-definidos-editar.vue?vue&type=script&lang=js&"
import style0 from "./objetivos-definidos-editar.vue?vue&type=style&index=0&id=71bdd8db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdd8db",
  null
  
)

export default component.exports